/* eslint-disable */
import { Typography} from '@material-ui/core';
import { useSelector } from 'react-redux';
import CheckBoxOption from './CheckBoxOption';

const UserPermissionSection = ({ classes, values, backendErrors, setBackendErrors, isOwnerAccDS }) => {
  const { en: { forms } } = useSelector((state) => state.i18n);

  return <div className={classes.section}>
      <Typography className={classes.sectionTitle}>
        {forms.userPermissions || 'User Permissions'}
      </Typography>
      <div className={classes.sectionContent}>
        <CheckBoxOption
          optionKey={'managesUsers'}
          backendErrors={backendErrors}
          setBackendErrors={setBackendErrors}
        />

        <CheckBoxOption
          optionKey={'administerClaims'}
          onChange={(checked, form, field) => {
            if (!checked) {
              form.setFieldValue('userPermissions.receiveClaimsEmails', false);
              setBackendErrors({
                ...backendErrors,
                'userPermissions.administerClaims': null,
              });
            }
            form.setFieldValue(field.name, checked);
          }}
          backendErrors={backendErrors}
          setBackendErrors={setBackendErrors}
        />

        {!isOwnerAccDS && (
          <CheckBoxOption
            optionKey={'receiveClaimsEmails'}
            disabled={!values?.userPermissions?.administerClaims}
            backendErrors={backendErrors}
            setBackendErrors={setBackendErrors}
          />
        )}

        <CheckBoxOption
          optionKey={'imminentRiskEmails'}
          onChange={(checked, form, field) => {
            if (!checked) {
              form.setFieldValue('userPermissions.receiveClaimsEmails', false);
              setBackendErrors({
                ...backendErrors,
                'userPermissions.imminentRiskEmails': null,
              });
            }
            form.setFieldValue(field.name, checked);
          }}
          backendErrors={backendErrors}
          setBackendErrors={setBackendErrors}
        />

        {!isOwnerAccDS && (
          <CheckBoxOption
            optionKey={'receiveSurveysEmails'}
            backendErrors={backendErrors}
            setBackendErrors={setBackendErrors}
          />
        )}

        <CheckBoxOption
          optionKey={'managesAlert'}
          backendErrors={backendErrors}
          setBackendErrors={setBackendErrors}
        />
      </div>
    </div>;
};

export default UserPermissionSection;
